<template>
  <div class="month-purchases-chart">
    <div v-if="loading" class="text-center py-4">
      <span class="fa fa-spinner fa-spin fa-5x"></span>
    </div>

    <template v-else>
      <div class="alert alert-primary mb-2" role="alert">
        Você pode ocultar barras do gráfico clicando na legenda abaixo.
      </div>

      <div class="row justify-content-center mb-2">
        <div class="col-md-2 clickable" @click="ocultarQuantidade">
          <div class="retangulo" style="background-color: red">
            <span :class="chartPayload.datasets[1].hidden ? 'tachar' : ''">Quantidade</span>
          </div>
        </div>
        <div class="col-md-2 clickable" @click="ocultarValor">
          <div class="retangulo" :style="'background-color: ' + env2.chartBarBackgroundColor">
            <span :class="chartPayload.datasets[0].hidden ? 'tachar' : ''">Valor</span>
          </div>
        </div>
      </div>

      <div v-if="ready" class="month-purchases-chart__canvas">
        <vue3-chart-js
          :key="chartKey"
          :id="chartId"
          ref="chartRef"
          type="bar"
          :data="chartPayload"
          :options="options"
        />
      </div>

      <div v-else class="alert alert-warning mb-0" role="alert">
        Não foi possível carregar os dados do gráfico.
      </div>
    </template>
  </div>
</template>

<script>
import Vue3ChartJs from "@j-t-mcc/vue3-chartjs";
import env from "../../env.js";

function createEmptyChartPayload() {
  return {
    labels: [],
    datasets: [
      {
        label: "Valor",
        type: "bar",
        backgroundColor: env.chartBarBackgroundColor,
        data: [],
        order: 1,
        yAxisID: "yA",
        borderWidth: 1,
        borderRadius: 10,
        borderSkipped: false,
      },
      {
        label: "Quantidade",
        type: "line",
        backgroundColor: "red",
        data: [],
        order: 0,
        borderColor: "red",
        fill: false,
        yAxisID: "yB",
      },
    ],
  };
}

export default {
  props: ["contract"],
  components: {
    Vue3ChartJs,
  },
  data() {
    return {
      chartId: "month-purchases-chart",
      loading: true,
      ready: false,
      chartKey: 0,
      delayed: false,
      env2: {
        chartBarBackgroundColor: "#222",
      },
      chartPayload: createEmptyChartPayload(),
      options: {
        animation: {
          onComplete: () => {
            this.delayed = true;
          },
          delay: (context) => {
            let delay = 0;
            if (
              context.type === "data" &&
              context.mode === "default" &&
              !this.delayed
            ) {
              delay = context.dataIndex * 200 + context.datasetIndex * 100;
            }
            return delay;
          },
        },
        interaction: {
          mode: "point",
        },
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false,
          },
        },
        scales: {
          x: {
            grid: {
              display: false,
            },
          },
          yA: {
            type: "linear",
            position: "left",
            beginAtZero: true,
          },
          yB: {
            type: "linear",
            position: "right",
            beginAtZero: true,
            grid: {
              drawOnChartArea: false,
            },
          },
        },
      },
    };
  },
  mounted() {
    this.env2 = env;
    this.getChartData();
  },
  methods: {
    ocultarQuantidade() {
      this.chartPayload.datasets[1].hidden = !this.chartPayload.datasets[1].hidden;
      this.$refs.chartRef?.update();
    },
    ocultarValor() {
      this.chartPayload.datasets[0].hidden = !this.chartPayload.datasets[0].hidden;
      this.$refs.chartRef?.update();
    },
    buildFilters() {
      if (!this.contract) {
        return "";
      }

      return (
        "CN9_FILIAL=" +
        this.contract.CN9_FILIAL.substr(0, 7) +
        "&CN9_NUMERO=" +
        this.contract.CN9_NUMERO +
        "&CN9_DTINIC=" +
        this.contract.CN9_DTINIC
      );
    },
    buildChartPayload(valueData, quantityData) {
      const labels = valueData.labels || [];
      const values = valueData.data || [];
      const quantities = quantityData.data || [];

      return {
        labels,
        datasets: [
          {
            label: "Valor",
            type: "bar",
            backgroundColor: env.chartBarBackgroundColor,
            data: values,
            order: 1,
            yAxisID: "yA",
            borderWidth: 1,
            borderRadius: 10,
            borderSkipped: false,
          },
          {
            label: "Quantidade",
            type: "line",
            backgroundColor: "red",
            data: quantities,
            order: 0,
            borderColor: "red",
            fill: false,
            yAxisID: "yB",
          },
        ],
      };
    },
    getChartData() {
      const filters = this.buildFilters();
      const valueApi = this.$store.getters.api + "contracts/chartValue?" + filters;
      const quantityApi = this.$store.getters.api + "contracts/chart?" + filters;

      this.loading = true;
      this.ready = false;

      Promise.all([axios.get(valueApi), axios.get(quantityApi)])
        .then(([valueResponse, quantityResponse]) => {
          const valueData = valueResponse.data?.data;
          const quantityData = quantityResponse.data?.data;

          if (!valueData?.labels || !Array.isArray(valueData.data)) {
            throw new Error("Resposta inválida de chartValue");
          }

          if (!Array.isArray(quantityData?.data)) {
            throw new Error("Resposta inválida de chart");
          }

          this.chartPayload = this.buildChartPayload(valueData, quantityData);
          this.chartKey += 1;

          this.$emit("setLastMonthValue", valueData.data[valueData.data.length - 1]);
          this.$emit(
            "setPenultimateMonthValue",
            valueData.data[valueData.data.length - 2]
          );
          this.$emit(
            "setLastMonthAmount",
            quantityData.data[quantityData.data.length - 1]
          );
          this.$emit(
            "setPenultimateMonthAmount",
            quantityData.data[quantityData.data.length - 2]
          );

          this.ready = true;
        })
        .catch((error) => {
          console.error("[MonthPurchases] erro ao carregar gráfico:", error);
          this.ready = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.month-purchases-chart {
  width: 100%;
  margin-bottom: 1.5rem;
}

.month-purchases-chart__canvas {
  position: relative;
  width: 100%;
  height: 300px;
  overflow: hidden;
  z-index: 0;
}

.month-purchases-chart__canvas :deep(canvas) {
  max-width: 100% !important;
}

.retangulo {
  display: inline-flex;
  align-items: center;
  width: 50px;
  height: 20px;
  font-size: 16px;
}

.retangulo span {
  margin-left: 58px;
}

.tachar {
  text-decoration: line-through;
}
</style>
